module.exports = "../dist/frontend/icons/symbols/ui/mock.svg?3a8b970f40c1fe183c260e2f7487835b";